import { Pipe, PipeTransform } from '@angular/core';
import { AgentsCacheService } from '../services/agents-cache.service';

@Pipe({ name: 'agentRoleFilter' })
export class AgentRoleFilter implements PipeTransform {
  constructor(public agentsCache: AgentsCacheService) {}

  transform(agentIds: any[], role: any): any {
    if (!agentIds || !role) {
      return agentIds;
    }
    const filteredRoles = role instanceof Array ? role : [role];
    return agentIds.filter((agentId) => {
      const agent = this.agentsCache.getAgent(agentId);
      return agent && filteredRoles.includes(agent.role);
    });
  }
}
